const jaJP = {
  'action.adjust': '設定を調整',
  'action.applyCrop': 'トリミングして再生成',
  'action.applyRecommended': '推奨サイズを適用',
  'action.applySize': 'サイズを適用',
  'action.cancel': 'キャンセル',
  'action.cancelConversion': '変換をキャンセル',
  'action.chooseImage': '画像を選択',
  'action.aiCartoon': '✨ AI カートゥーン化',
  'aiCartoon.note': '写真をカートゥーン調に描き直してから変換します（約 30 秒）',
  'status.aiCartoonWorking': 'AI がカートゥーン調に描き直しています…（約 30 秒、ページを閉じないでください）',
  'status.aiCartoonPending': 'AI に送信しました。結果を待っています…',
  'status.aiCartoonFetch': 'カートゥーン画像が完成。図案を再変換中…',
  'toast.aiCartoonDone': 'カートゥーン化が完了しました',
  'toast.aiCartoonFailed': 'AI カートゥーン化に失敗：{reason}',
  'toast.aiCartoonNoImage': '先に画像を選択してください',
  'toast.aiCartoonTimeout': 'AI 処理がタイムアウトしました。後でもう一度お試しください',
  'action.clearDraft': '復元データを消去',
  'action.close': '閉じる',
  'action.contribute': '貢献する',
  'action.copyLink': 'リンクをコピー',
  'action.cropRegion': '範囲をトリミング',
  'action.downloadOffline': 'オフライン版をダウンロード',
  'action.exportBuildSheet': '制作図を出力',
  'action.exportCsv': 'CSV を出力',
  'action.exportPattern': '図案を出力',
  'action.exportPng': '色番号付き図案 PNG を出力',
  'action.exportShareCard': '共有カードを出力',
  'action.loadProject': 'プロジェクトを開く',
  'action.markColorDone': 'この色を完了にする',
  'action.markColorUndone': '未完了に戻す',
  'action.ok': '了解',
  'action.print': '印刷 / ページ分割',
  'action.regenerate': 'この設定で再生成',
  'action.reportIssue': '問題を報告',
  'action.resetCrop': '元画像全体にリセット',
  'action.resetMaking': '進捗をリセット',
  'action.restoreDraft': '未完成の図案を復元',
  'action.restoreFullImage': '元画像の範囲に戻す',
  'action.saveProject': '編集可能プロジェクトを保存（元画像なし）',
  'action.share': '共有',
  'action.showAllColors': 'すべて表示',
  'action.star': 'GitHub でスター',
  'action.startMaking': '制作を開始',
  'action.trySample': 'サンプルを試す',
  'advanced.autoConfigured': 'ワンクリックモードで自動設定済み',
  'advanced.title': '詳細設定',
  'advice.expressiveness': '現在の表現力',
  'advice.kicker': '表現力チェック',
  'advice.perBead': '1粒あたりの元ピクセル数',
  'advice.text': '現在のマス数では、この複雑な画像のすべての詳細を保持できません。',
  'advice.title': '画像を主要な部分にトリミングしてください',
  'app.heading': 'Bead Grid Studio：アイロンビーズ図案ジェネレーター',
  'app.skipCanvas': '図案キャンバスへスキップ',
  'aria.boardLayout': 'プレート配置',
  'aria.chooseColor': '{code} {name} を選択',
  'aria.closeControls': '設定を閉じる',
  'aria.closeCrop': '切り抜きダイアログを閉じる',
  'aria.closeMaking': '制作アシスタントを閉じる',
  'aria.closePalette': 'パレットを閉じる',
  'aria.closeProduct': '製品情報を閉じる',
  'aria.closeShare': '共有ダイアログを閉じる',
  'aria.codesOff': 'マスごとの色番号を非表示',
  'aria.codesOn': 'マスごとの色番号を表示',
  'aria.codesZoom': '色番号は有効です。ズームして確認してください',
  'aria.communityActions': 'オープンソースコミュニティリンク',
  'aria.controls': '図案の設定',
  'aria.copyStats': 'すべての色番号と数量をプレーンテキストでコピー',
  'aria.cropPreview': '切り抜きプレビュー',
  'aria.focusColor': '{code} を強調表示、残り {count} 粒',
  'aria.help': 'ヘルプ、プライバシー、バージョン情報',
  'aria.localPromises': 'ローカル＆オフライン機能保証',
  'aria.makingActions': '制作アシスタントの操作',
  'aria.makingProgress': 'ビーズ制作進捗',
  'aria.markColorDone': '{code} を完了にする',
  'aria.markColorUndone': '{code} を未完了に戻す',
  'aria.mobilePanels': 'モバイルパネル',
  'aria.nextColor': '次の色へ',
  'aria.paletteRange': 'パレット規格',
  'aria.paletteSeries': '色系統で絞り込み',
  'aria.paletteStats': 'パレットと使用数',
  'aria.patternCanvas': '{cols} × {rows} のアイロンビーズ図案。矢印キーで移動、Spaceで描画、Deleteで消去。',
  'aria.presets': '長辺プリセット',
  'aria.preview': 'プレビュー表示形式',
  'aria.previousColor': '前の色へ',
  'aria.printImage': '印刷用に準備されたアイロンビーズ図案',
  'aria.printSheet': '印刷用図案',
  'aria.projectLicense': 'プロジェクトとライセンス',
  'aria.readyActions': '図案完成後の操作',
  'aria.redo': 'やり直す',
  'aria.searchPalette': 'パレットを検索',
  'aria.sharePreview': '共有カードプレビュー',
  'aria.sizeMode': 'サイズ指定方法',
  'aria.stage': '図案プレビューとエディタ',
  'aria.statShare': '全ビーズの {percent}',
  'aria.steps': '使い方ガイド',
  'aria.tools': '描画ツール',
  'aria.undo': '元に戻す',
  'aria.viewOptions': '表示オプション',
  'aria.zoom': 'キャンバスの拡大縮小',
  'aria.zoomIn': '拡大',
  'aria.zoomOut': '縮小',
  'board.artkal50': 'Artkal ミニ 2.6mm · 50×50マス/枚',
  'board.artkal78': 'Artkal ミニ 2.6mm · 78×78マス/枚',
  'board.compatibilityNote': '50マス板と52マス板はピンの間隔が異なる場合があります。お持ちのプレートの正確な規格を選択してください。',
  'board.initialText': '画像を読み込むと、実際の占有マス数、余白、プレート枚数、仕上がり寸法が表示されます。',
  'board.initialTitle': '52×52 プレート · 図案は元の縦横比を維持',
  'board.layout.1x1': '1×1枚',
  'board.layout.1x2': '縦に2枚',
  'board.layout.2x1': '横に2枚',
  'board.layout.2x2': '2×2枚',
  'board.layout.2x3': '2×3枚',
  'board.layout.3x2': '3×2枚',
  'board.midi14': '小型 5mm · 14×14マス/枚',
  'board.midi29': '標準 5mm · 29×29マス/枚',
  'board.mini26': '小型ミニ 2.6mm · 26×26マス/枚',
  'board.mini52': '標準ミニ 2.6mm · 52×52マス/枚',
  'board.profile': '実物プレート',
  'board.statusBody': '{profile} × {count}枚；約 {width}×{height}cm。中央配置：左右余白 {left}/{right}列、上下余白 {top}/{bottom}行、空き {blank}マス。',
  'board.statusTitle': 'プレート {boardCols}×{boardRows} · 図案 {patternCols}×{patternRows}（等比）',
  'brand.aria': 'Bead Grid Studio',
  'brand.name': 'Bead Grid Studio',
  'brand.tagline': 'アイロンビーズ図案ジェネレーター',
  'canvas.help': '矢印キーでカーソル移動、スペースキーで描画、Deleteキーで消去します。',
  'confirm.boardQualityLow': '\n\n明瞭度メモ：単板はシンプルなイラスト向けです。写真などの複雑な画像には104マス以上をおすすめします。',
  'confirm.boardQualitySevere': '\n\n明瞭度の警告：このプレートでは主輪郭と大まかな色分けのみ保持されます。文字や細かいディテールは再現できません。',
  'confirm.boardSwitch': '{profile}、{tilesX}×{tilesY} 枚の構成に切り替え、「図案 {patternCols}×{patternRows} / プレート {boardCols}×{boardRows}」を生成しますか？手動編集は破棄されますが、完了後に元に戻せます。{quality}\n\n続行しますか？',
  'confirm.clear': '現在の図案をすべて消去しますか？この操作は元に戻せます。',
  'confirm.clearDraft': 'ブラウザに自動保存された復元データのみを消去します（保存したファイルは消去されません）。消去しますか？',
  'confirm.coverCrop': 'キャンバス全体を埋めると、元画像の約 {percent}% が切り取られます。主要な被写体が端にないことを確認してください。切り抜いて続行しますか？',
  'confirm.exportIssues': 'この図案には {issues} があります。サイズを拡大するかブラシで修正することをおすすめします。このまま出力しますか？',
  'confirm.loadProject': '現在の図案に未保存の変更があります。別のプロジェクトを読み込むと上書きされます。保存する場合は「キャンセル」を選択してください。\n\n変更を破棄して続行しますか？',
  'confirm.patternMode': '図案明瞭度優先モードに切り替え、プレートから {cols}×{rows} の図案を取り出して再生成しますか？手動編集は置き換えられますが、元に戻せます。続行しますか？',
  'confirm.printPages': 'この {cols}×{rows} の図案は1ページ最大 {span}×{span} マス（全 {pages} ページ）に分割印刷されます。各ページに全体座標、色番号、補助線、使用数が記載されます。続行しますか？',
  'confirm.replaceImage': '現在の図案に未保存の変更があります。別の画像を選択すると上書きされます。保存する場合は「キャンセル」を選択してください。\n\n変更を破棄して続行しますか？',
  'confirm.resetMaking': '色ごとの制作進捗をすべてリセットしますか？図案そのものは変更されません。',
  'confirm.resize': '{cols}×{rows} に変更し、元画像から再生成しますか？現在の手動編集内容は破棄されますが、元に戻せます。{quality}\n\n続行しますか？',
  'confirm.resizeQuality': '\n\n明瞭度の警告：有効マス数は約 {cells} マスのみです。主輪郭とおおまかな塗りつぶしは残りますが、文字や細部は失われます。',
  'conversion.analyzing': '画像とパレットを解析中…',
  'conversion.backgroundRemoved': '、輪郭外の背景は余白化済み',
  'conversion.colorsMerged': '、{before} 色から {after} 色に統合済み',
  'conversion.progress': '{mode} で処理中 · 最大 {colors} 色…',
  'conversion.title': 'アイロンビーズ図案を生成中',
  'crop.height': '高さ %',
  'crop.help': '画像上をドラッグして四角形を指定するか、下部の数値を入力してください。イラストや写真の主体を絞るほど、1粒あたりの情報量が増えて綺麗に仕上がります。',
  'crop.left': '左余白 %',
  'crop.precise': '正確なトリミング（元画像に対するパーセント）',
  'crop.sourcePixels': '{width} × {height} 元ピクセル',
  'crop.title': '制作したい範囲を切り抜き',
  'crop.top': '上余白 %',
  'crop.width': '横幅 %',
  'csv.code': '色番号',
  'csv.completed': '完了状況',
  'csv.count': '数量',
  'csv.packs': '必要袋数',
  'csv.hex': '画面参考 HEX',
  'csv.name': '色名',
  'csv.no': '未完了',
  'csv.yes': '完了',
  'draft.clear': '復元データを消去',
  'draft.restore': '未完成の図案を復元',
  'dropzone.note': '画像タイプを自動判別し、黒白を補正して比率を維持。制作前にプレートと色見本をご確認ください。',
  'dropzone.title': '画像を選択 · アイロンビーズ図案をスマート生成',
  'export.boardCopy': '{profile} × {tilesX}×{tilesY}枚 · 図案 {cols}×{rows}',
  'export.boardSize': '図案 {patternCols}×{patternRows} · プレート {boardCols}×{boardRows} · {boards} 枚',
  'export.count': '{count} 粒',
  'export.generated': 'Bead Grid Studio v{version} · ローカル生成',
  'export.header': '{title} · {cols}列 × {rows}行 · {colors}色 · 合計 {beads}粒',
  'export.materials': '材料リスト',
  'export.patternCopy': '元画像の縦横比に準拠した図案寸法',
  'export.patternSize': '{cols} 列 × {rows} 行',
  'export.sizeSummary': '図案サイズ: {size} · 補助線 {step}マスごと',
  'export.subtitle': 'MARD 互換基本 221 色 · {board} · 補助線 {step}マスごと · 色番号入り',
  'export.total': '必要な総ビーズ数: {count} 粒',
  'field.fitMode': '配置方式',
  'field.lightBackground': '薄い背景',
  'field.maxColors': 'この図案で使用する最大色数',
  'field.maxColorsNote': '自動マッチングは現在のパレットから最も近い色を選択します。これはこの図案で使う色数を制限するもので、パレット全体の制限ではありません。',
  'field.mergeNote': '値を高くすると似た色がまとまり、すっきりした配色になります。濃い輪郭と鮮やかな色は優先して残ります。',
  'field.mergeStrength': '類似色の統合',
  'field.processMode': '変換モード',
  'field.protectDark': '純黒の保護',
  'field.protectDarkNote': '圧縮や光の反射でくすんだ黒が、濃紺や茶色、紫色に誤判定されるのを防ぎます。',
  'field.referenceOpacity': '元画像との比較表示',
  'file.cropped': '切り抜き · {width}×{height} 元ピクセル',
  'file.details': '{width} × {height} · {size} MB{suffix}',
  'file.patternFallback': 'bead-pattern',
  'file.restored': '元画像の範囲を完全に復元',
  'file.trimmed': ' · 主体に自動密着',
  'fit.contain': '全体を表示',
  'fit.cover': '全体を埋めて切り抜き',
  'footer.license': 'オープンソースライセンス',
  'footer.notices': 'サードパーティ表記',
  'footer.privacy': 'プライバシー',
  'footer.terms': '利用規約',
  'hero.flow1': '画像を配置',
  'hero.flow2': '図案を生成',
  'hero.flow3': '自動色合わせ',
  'hero.flow4': 'ビーズ数集計',
  'hero.flow5': '図案を出力',
  'hero.local': '100% ブラウザ内でローカル処理',
  'hero.noAccount': 'アカウント不要',
  'hero.noInstall': 'インストール不要',
  'hero.noUpload': '画像アップロードなし',
  'hero.offline': 'オフライン対応',
  'hero.text': '画像をドラッグ＆ドロップして、色合わせ、ビーズ数カウント、印刷用図案の出力をすべて完結。',
  'hero.title': '画像 → アイロンビーズ図案',
  'history.boardChanged': 'プレート仕様を変更しました',
  'history.cleared': '図案をクリアしました',
  'history.converted': '画像を変換しました',
  'history.edited': '図案を編集しました',
  'history.keyboardDraw': 'キーボードで描画しました',
  'history.keyboardErase': 'キーボードで消去しました',
  'history.mirroredH': '左右反転しました',
  'history.mirroredV': '上下反転しました',
  'history.rotated': '時計回りに 90° 回転しました',
  'history.sizeCleared': '図案サイズを変更してキャンバスをクリアしました',
  'history.stroke': '描画ストロークを完了しました',
  'history.undoAvailable': '{label} · {count} 段階元に戻せます',
  'language.chinese': '中文',
  'language.english': 'EN',
  'language.french': 'FR',
  'language.japanese': '日本語',
  'language.korean': '한국어',
  'language.label': '表示言語',
  'legend.codesZoom': '拡大して色番号を確認',
  'legend.empty': '変換後に色番号と使用数が表示されます',
  'legend.title': '凡例',
  'making.allColors': '全色を表示中',
  'making.allColorsDetail': 'リストの行を選択すると再度その色にフォーカスします',
  'making.allDone': 'すべての色が完了しました',
  'making.allDoneDetail': '制作図と照らし合わせて最終確認を行ってください',
  'making.chooseColor': '材料リストから色を選択してください',
  'making.focusedCount': 'この色で確認が必要なビーズ: {count} 粒',
  'making.kicker': '制作アシスタント',
  'making.progress': '{done}/{total} 粒 · {colorsDone}/{totalColors} 色 · {percent}%',
  'making.progressAria': '{percent}% 完了、{totalColors} 色中 {colorsDone} 色完了',
  'making.title': '1色ずつ順番にビーズを配置',
  'meta.description': '画像を色番号・補助線・使用数付きの印刷可能なアイロンビーズ図案に変換。完全ローカル処理。',
  'meta.ogDescription': '色合わせ、ビーズ数カウント、図案編集、印刷用図案の出力まで、すべてブラウザ内でローカル処理。',
  'meta.ogLocale': 'ja_JP',
  'meta.ogTitle': 'Bead Grid Studio · 画像からアイロンビーズ図案',
  'meta.schemaDescription': 'ブラウザで画像を編集・印刷可能なアイロンビーズ図案に変換するローカルファーストの図案ジェネレーター。',
  'meta.schemaName': 'Bead Grid Studio',
  'meta.title': 'Bead Grid Studio — 画像からアイロンビーズ図案を生成',
  'mobile.palette': 'パレット',
  'mobile.pattern': '図案',
  'mobile.stats': '用量',
  'mobile.tools': 'ツール',
  'mode.cartoon': 'アイコン・線画 · 輪郭優先',
  'mode.detail': '詳細写真 · 明暗維持',
  'mode.document': '文書構造 · レイアウト維持',
  'mode.photo': '自然写真 · エリア平均',
  'mode.pixel': 'ドット絵サンプリング · 平滑化なし',
  'modeHint.cartoon': 'イラスト、線画、ロゴ向け。黒い輪郭と高彩度の微細なアクセントを保持します。',
  'modeHint.detail': 'ポートレート、ペット、写真向け。暗い構造を守りつつ局所コントラストを強調します。',
  'modeHint.document': '論文、スクリーンショット、図解向け。微小な文字を抑制し、罫線や広い塗りつぶしを維持します（本文は読めなくなります）。',
  'modeHint.photo': '写真、グラデーション、柔らかい光向け。リニアライト空間で各マスを平均化します。',
  'modeHint.pixel': 'すでにドット絵の画像向け。平滑化せず各マスの中心ピクセルをサンプリングします。',
  'output.major10': '10マスごと（推奨）',
  'output.major29': '29マスごと（一般的な 5mm 四角プレート）',
  'output.major5': '5マスごと',
  'output.majorGrid': '太い補助線の間隔',
  'output.majorNote': '画面プレビューと最終制作図で同じ補助線が表示され、位置確認やプレート結合に便利です。',
  'output.subtitle': 'PNG / JSON / 印刷',
  'output.title': 'プロジェクトと出力',
  'palette.all': 'すべて',
  'palette.black': '黒',
  'palette.countAll': '221 色 · 9 系列',
  'palette.countSeries': '{series} 系列 · {count} 色',
  'palette.note': '現在は MARD 互換基本 221 色（A/B/C/D/E/F/G/H/M）に対応。H1 は透明色で手動描画専用です。自動変換は 220 の実色を使用し、白は H2、黒は H7 に固定されます。画面上の HEX は目安です。実物ビーズでご確認ください。',
  'palette.panel': 'パレットと材料',
  'palette.provider': 'MARD 互換基本 221 色',
  'palette.search': '色番号や系列名で検索',
  'palette.series.A': 'イエロー・オレンジ系',
  'palette.series.B': 'グリーン系',
  'palette.series.C': 'ブルー・シアン系',
  'palette.series.D': 'ブルー・パープル系',
  'palette.series.E': 'ピンク・ローズ系',
  'palette.series.F': 'レッド系',
  'palette.series.G': 'ブラウン・スキンカラー系',
  'palette.series.H': 'モノトーン系',
  'palette.series.M': 'アースカラー系',
  'palette.title': 'パレット',
  'palette.transparent': '透明',
  'palette.white': '白',
  'panel.image': '画像と変換',
  'panel.localProcessing': 'ローカル処理',
  'panel.tools': 'ツールと設定',
  'preview.bead': 'ビーズ風プレビュー',
  'preview.square': 'カラーブロック',
  'print.count': '{code} · {count} 粒',
  'print.materials': 'このページの材料',
  'print.pageSubtitle': '全体 {cols}×{rows} · このページ 列 {startCol}–{endCol} / 行 {startRow}–{endRow} · 互換 221 色番号',
  'print.pageTitle': '{title} · ページ {page}/{pages}',
  'product.colorText': '本ツールは MARD 互換基本 221 色のデータを使用しています。各ビーズメーカーとの提携・公認関係はありません。画面の色は参考値です。',
  'product.colorTitle': 'カラーおよび商標に関する注記',
  'product.intro': 'Bead Grid Studio は完全ブラウザ完結型のオープンソース図案ツールです。アカウント登録、課金、クラウドへの画像送信は一切ありません。',
  'product.performanceText': '50マス板と52マス板はピン間隔が異なる場合があります。大判の図案ではメモリ保護のため拡大率が自動制御されます。',
  'product.performanceTitle': 'プレートとパフォーマンス',
  'product.privacy': 'プライバシー',
  'product.privacyText': '画像は外部サーバーに送信されません。作成途中の図案データは元画像を含めずにブラウザ内に一時保存され、いつでも消去できます。',
  'product.privacyTitle': 'プライバシーとデータ復元',
  'product.repo': 'オープンソースリポジトリ',
  'product.step1': '画像を選択し、必要に応じて主体をトリミングします。',
  'product.step2': '縦横比、使用プレート、色数、ビーズ数を確認・調整します。',
  'product.step3': '色番号付きの図案を出力します。大きい図案は分割印刷が便利です。',
  'product.stepsTitle': '3ステップの使い方',
  'product.terms': '利用規約',
  'product.title': 'ヘルプ・プライバシー・バージョン情報',
  'product.version': 'バージョン',
  'project.defaultName': 'bead-pattern-project',
  'project.fileDescription': 'Bead Grid Studio 編集可能プロジェクト',
  'project.imageLocal': '{width} × {height} · ローカル処理済み',
  'project.importedName': '読み込んだ図案',
  'project.loadedSubtitle': 'JSON プロジェクトを読み込みました · 元画像は含まれません',
  'project.localOnly': '画像はこのブラウザ内でのみ処理されます',
  'project.recoveryFile': 'recovery.bead.json',
  'project.untitled': '無題の図案',
  'prompt.projectName': 'プロジェクト名は JSON に保存されます。元ファイル名に個人名や注文番号が含まれる場合はここで変更してください。',
  'punctuation.list': '、',
  'quality.alreadySize': '現在すでに {cols}×{rows}',
  'quality.aspectMismatch': '図案の縦横比の不一致',
  'quality.aspectShort': '{cols}×{rows} は元画像の比率と一致していません。{result}',
  'quality.aspectTitle': '{cols}×{rows} は元画像の比率と一致しません',
  'quality.aspectWarning': '縦横比とトリミングの警告',
  'quality.cellConflict': 'マスの競合',
  'quality.crop': '主要な部分を切り抜く',
  'quality.cropBody': 'キャンバス全体を埋めると、元画像の約 {percent}% が切り取られます。端にある被写体が消える可能性があります。',
  'quality.cropChoose': '切り抜いて主体を選択',
  'quality.cropPercent': '切り取り {percent}%',
  'quality.cropSubject': '主体を切り抜き',
  'quality.cropSuggestion': 'まず狭い範囲に切り抜くことをおすすめします',
  'quality.cropVerb': '切り抜き',
  'quality.cropsContent': '元画像の一部が切り取られます',
  'quality.detailBody': '{warning}。1段階大きいサイズにするか、ブラシツールで補正してください。',
  'quality.detailCollisions': '{count} 箇所の競合が分離できません',
  'quality.detailConflict': '一部の細部が現在のマス数を超えています',
  'quality.detailIntegrity': '{details}；架空のビーズ追加や不要な線の結合は行われていません',
  'quality.detailShort': '{size}: {warning}；余分なビーズは強制追加されていません',
  'quality.documentBody': '{size} ではレイアウトや大きな塗りつぶしのみ残り、本文は読めなくなります。{modeAdvice}ビーズ1粒 {beadMm}mm の場合、仕上がり寸法は約 {width}×{height}cm です。',
  'quality.documentModeAdvice': '下の「文書構造」モードへの切り替えを推奨します。',
  'quality.documentTitle': '文書全体は判読可能な範囲を超えています',
  'quality.documentWarning': '文書の表現力警告',
  'quality.fixAspect': '比率を {cols}×{rows} に修正',
  'quality.fixAspectShort': '縦横比を修正',
  'quality.glyphHeight': '本文の高さは約 {height} マス相当',
  'quality.hasMargins': '大きな余白が生じます',
  'quality.increaseSize': '{cols}×{rows} に拡大 · {beadMm}mm で約 {width}×{height}cm',
  'quality.largeStructureOnly': '大まかな構造のみ',
  'quality.letterboxBody': '画像は歪んでいませんが、図案の約 {percent}% が余白になります。有効領域は約 {cols}×{rows} マスです。元画像の比率を維持することをおすすめします。',
  'quality.marginPercent': '余白 {percent}%',
  'quality.marginVerb': '余白を追加',
  'quality.missingDetails': '{count} 箇所のディテールが1マス未満です',
  'quality.modeOrCropSuggestion': '文書構造モードに切り替えるか切り抜きを行ってください',
  'quality.oneSubject': '単一の主体のみ制作',
  'quality.outlineOnly': 'このサイズでは輪郭のみ保持可能です',
  'quality.outlineShort': '{size} では主輪郭と大まかな塗りつぶしのみ保持されます。',
  'quality.photoBody': '有効長辺は約 {long} マス（有効 {cells} マス）のみです。小さな文字や境界は失われます。',
  'quality.photoDetailTitle': '現在のマス数では写真のすべての細部を表現できません',
  'quality.pixelsPerBead': '1マスあたり約 {count} ピクセル',
  'quality.smallWarning': '小サイズ図案の細部警告',
  'quality.sourcePixels': '{x}×{y} 元ピクセル',
  'quality.structureOnlyShort': '{size} では大まかなレイアウトのみ保持されます。{action}',
  'quality.text': '本文の文字や細かい線は潰れる可能性があります',
  'quality.textTooSmall': '文字が小さすぎて表現できません',
  'quality.title': 'この画像は現在のマス数の許容量を超えています',
  'ready.kicker': '図案完成 🎉',
  'ready.text': '出力や共有の前に、図案、色番号、ビーズ数を確認してください。',
  'share.cardFooter': 'github.com/zwhy149/bead-grid-studio',
  'share.cardSubtitle': 'ローカル処理 • 編集可能 • 印刷対応 • オープンソース',
  'share.cardTitle': '画像 → アイロンビーズ図案',
  'share.copied': 'リンクをコピーしました',
  'share.dialogHelp': '共有カードは手動で要求された時のみ生成されます。制作図の変更や元画像のアップロードは行いません。',
  'share.dialogTitle': '共有カードを出力',
  'share.download': '共有カードをダウンロード',
  'share.failed': '共有機能が利用できないため、リンクをコピーしました。',
  'share.formatLabel': 'カードの縦横比',
  'share.original': '元画像',
  'share.pattern': 'ビーズ図案',
  'share.portrait': '3:4 · スマートフォン / SNS 投稿向け',
  'share.text': 'Bead Grid Studio でアイロンビーズの図案を作りました 🫘',
  'share.title': 'Bead Grid Studio で作成したアイロンビーズ図案',
  'share.unavailable': 'このプロジェクトには元画像が含まれていないため、比較カードを生成できません。',
  'share.wide': '16:9 · X / Reddit / Discord 向け',
  'size.aspectInitial': '画像を選択後、プリセットは正方形への変形ではなく図案の長辺を設定します。',
  'size.aspectLocked': '元画像の比率 {ratio}:1 に固定中。プリセットを選ぶと {cols}×{rows} のように等比で設定されます。',
  'size.aspectUnlocked': '比率固定解除中。「全体表示」は余白を追加し、「切り抜き」ははみ出し部分をカットします。',
  'size.aspectUnlockedInitial': '縦横比固定解除中。画像選択後は縦横を個別に設定できます。',
  'size.boardCols': 'プレート合計列数',
  'size.boardMode': '実物プレートで指定',
  'size.boardRows': 'プレート合計行数',
  'size.lockAspect': '縦横比を固定（推奨）',
  'size.longSide': ({ size }) => `長辺 ${size}`,
  'size.patternAndBoard': '図案 {patternCols}×{patternRows} / プレート {boardCols}×{boardRows}',
  'size.patternHeight': '図案の高さ',
  'size.patternMode': '図案の細かさで指定',
  'size.patternOnly': '図案 {cols}×{rows}',
  'size.patternWidth': '図案の横幅',
  'size.subtitle': '図案とプレートは別々に設定可能',
  'size.title': '図案サイズ',
  'smart.calculating': '推奨設定を計算中',
  'smart.cropFirst': 'まずエリアを1つ切り抜く',
  'smart.custom': 'カスタム設定を使用中',
  'smart.customAspect': 'カスタムサイズが元画像の比率と一致していません',
  'smart.customCapacity': '現在の {cols}×{rows} の有効マス数は約 {cells} マスです。サイズを大きくするか被写体を切り抜いてください。',
  'smart.customIssues': '現在の {cols}×{rows}: {warning}。次のサイズに拡大するかブラシで補正してください。',
  'smart.customMismatch': 'これにより約 {percent}% の{effect}が生じます。下の「縦横比を修正」を使用してください。',
  'smart.customSummary': '現在 {cols}×{rows}、最大 {colors} 色。いつでも自動推奨に戻せます。',
  'smart.customTooSmall': 'カスタムサイズが小さすぎるため、大まかな輪郭のみとなります',
  'smart.defaultSummary': 'サイズ、変換モード、パレット、プレビューを自動選択します。',
  'smart.detailWarning': '{warning}。{size} マスに拡大するかブラシで補正してください。',
  'smart.documentSummary': '最大 {cols}×{rows} でレイアウトと大まかな塗りつぶしを保持します。制作したい単一エリアを切り抜いてください。',
  'smart.documentUnreadable': '文字が多い全体文書は、ビーズ図案で文字を読めるようにはできません',
  'smart.generate': '自動生成する',
  'smart.generatedReview': '生成完了 — 出力前に確認してください',
  'smart.generatedSmallLine': '小サイズ線画の最適化が完了しました',
  'smart.generatedWithWarning': '生成されましたが、{warning}',
  'smart.kicker': 'かんたん自動モード',
  'smart.readySummary': '{size} · {beads} 粒 · {colors} 色 · 元の縦横比を維持。{framing}{detailWarning}{beadMm}mm ビーズで約 {width}×{height}cm。材料数は空白以外のマスと一致します。制作前に実物カラーをご確認ください。',
  'smart.recommendedReady': '推奨設定の準備完了',
  'smart.recommendedSummary': '{cols}×{rows} · {capacity} マス · 最大 {colors} 色 · {trimmed}MARD 互換基本 221 色 · 黒白補正済み · 色番号入り',
  'smart.regenerate': '再生成する',
  'smart.restore': '自動推奨設定に戻す',
  'smart.step1': '1 画像を追加',
  'smart.step2': '2 図案を確認',
  'smart.step3': '3 出力',
  'smart.trimmed': '余白の約 {percent}% を自動トリミングしました。いつでも元画像全体に戻せます。',
  'smart.trimmedShort': '外側余白を約 {percent}% 削減 · ',
  'stats.colors': '使用色数',
  'stats.copyList': '買い物リストをコピー',
  'stats.empty': '空きマス',
  'stats.emptyList': '画像を追加するかキャンバスに描画すると、色ごとの使用数がここに表示されます。',
  'stats.listLine': '{code} {name} · {count} 粒 · 約{packs}袋 · {percent}',
  'stats.listMeta': '図案: {cols} × {rows} マス · 合計 {total} 粒 · {colors} 色 · 購入 {packs} 袋',
  'stats.listTip': 'ブランドや製造ロットによって色味が異なる場合があります。購入前に見本帳で確認し、10%ほど多めに用意することをおすすめします。',
  'stats.listTitle': 'アイロンビーズ買い物リスト (Bead Grid Studio)',
  'stats.sorted': '数量順に並び替え',
  'stats.title': '材料・ビーズ数集計',
  'stats.packs': '≈{packs} 袋',
  'stats.totalPacks': '必要袋数',
  'stats.total': '総ビーズ数',
  'status.boardPattern': '図案 {patternCols}×{patternRows} / プレート {boardCols}×{boardRows}',
  'status.boardSwitched': '実物プレート規格を変更しました',
  'status.browserUnsupported': 'お使いのブラウザでは安全なバックグラウンド変換を開始できません',
  'status.canvasFit': '図案をウィンドウに合わせました',
  'status.canvasOverview': '全体表示 · 編集するにはズームインしてください',
  'status.cleared': '図案をクリアしました',
  'status.complexPreview': '複雑な文書のプレビュー',
  'status.conversionBlocked': '変換処理中 · 状態変更操作はブロックされています',
  'status.conversionCanceled': '変換をキャンセルし、直前の図案を復元しました',
  'status.conversionComplete': '変換完了 · {mode} · {size} · {colors} 色',
  'status.conversionFailed': '{reason} · 直前の完成図案を復元しました',
  'status.cropSuggested': 'まず単一エリアを切り抜いてください',
  'status.csvExported': '材料 CSV を出力しました · {colors} 色 · {beads} 粒',
  'status.documentPreview': '{kind} · 本文は判読不能 · {size} · {advice}',
  'status.draftCleared': 'ブラウザの復元記録を消去しました',
  'status.exportDone': '制作図 PNG の出力が完了しました',
  'status.exportFailed': 'PNG 出力に失敗しました',
  'status.exporting': '高解像度 PNG を生成中…',
  'status.failed': '変換に失敗しました',
  'status.generatingPixel': '{cols}×{rows} のピクセル精度図案を生成中…',
  'status.imageReadFailed': '画像の読み込みに失敗しました',
  'status.loadingSample': '内蔵サンプルを読み込み中…',
  'status.majorGrid': '太い補助線を {count} マスごとに設定しました',
  'status.makingStarted': '制作アシスタント有効 · 1色ずつ順番に確認できます',
  'status.makingStopped': '制作アシスタント終了 · 進捗はプロジェクトに保存されます',
  'status.mirroredH': '左右反転しました',
  'status.mirroredV': '上下反転しました',
  'status.modeSuggested': '文書構造モードへの変更または切り抜きを推奨',
  'status.printFailed': '印刷プレビューに失敗しました',
  'status.printReady': '{count} ページの印刷準備が完了しました · 印刷設定の「用紙に合わせる」重複拡大は無効にしてください',
  'status.projectDownloadStarted': 'プロジェクトのダウンロードを開始しました',
  'status.projectLoadFailed': 'プロジェクトの読み込みに失敗しました',
  'status.projectLoaded': '{cols}×{rows} プロジェクトを読み込みました{migration}',
  'status.projectMigration': ' · 互換基本 221 色に移行済み',
  'status.projectRestored': '未完成の {cols}×{rows} プロジェクトを復元しました',
  'status.projectSaved': 'プロジェクトファイルを保存しました',
  'status.readingImage': '画像を読み込み中…',
  'status.ready': '準備完了 · すべての処理はこの端末内で行われます',
  'status.redo': '操作をやり直しました',
  'status.rotated': '時計回りに 90° 回転しました',
  'status.sampleFailed': 'サンプルの読み込みに失敗しました',
  'status.sizeCleared': '図案サイズを変更しキャンバスをクリアしました',
  'status.smallRefine': '小サイズ最適化完了 · {warning} · より詳細にするにはマス数を増やしてください',
  'status.structurePreview': '文書構造プレビュー',
  'status.timeout': '変換がタイムアウトしました',
  'status.undo': '直前の操作を元に戻しました',
  'status.zoom': '{message} · ズーム {percent}%',
  'status.zoomValue': 'ズーム {percent}%',
  'title.codesToggle': 'マスごとの色番号の表示 / 非表示',
  'title.codesZoom': '色番号は有効です。各マスが14ピクセル以上になるまで拡大してください',
  'title.color': '{code} {name} {hex}',
  'title.fitCanvas': '図案全体をウィンドウに合わせる',
  'title.redo': 'やり直す Ctrl+Y',
  'title.toggleCodes': 'マスごとの色番号の表示 / 非表示',
  'title.toggleGrid': 'グリッドの表示 / 非表示',
  'title.toggleRuler': '目盛ルーラーの表示 / 非表示',
  'title.undo': '元に戻す Ctrl+Z',
  'title.zoomLimit': 'この図案の最大ズーム倍率: {percent}%',
  'toast.boardContainOnly': '実物プレートモードは全体表示を維持します。歪みや勝手なトリミングなく等比で中央配置されます。',
  'toast.boardTooLarge': 'プレート配置が160マスの制限を超えています。縦または横の枚数を減らしてください。',
  'toast.canvasFit': 'ズーム率を {percent}% に設定しました',
  'toast.canvasOverview': '図案全体を表示中。マスを個別に編集するには拡大してください。',
  'toast.chooseImageFirst': 'まず画像を選択してください。',
  'toast.codesNeedZoom': '現在は全体表示です。色番号を確認するには100%まで拡大してください。出力画像には常に色番号が含まれます。',
  'toast.colorDone': '{code} を完了にしました。次の色に進みます。',
  'toast.colorSelected': '{code} {name} を選択しました',
  'toast.colorUndone': '{code} を未完了に戻しました。',
  'toast.conversionBusy': '画像を変換中です。完了をお待ちいただくか、キャンセルしてください。',
  'toast.conversionCanceled': '変換がキャンセルされ、前の図案が保持されました。',
  'toast.conversionComplete': '変換完了: {colors} 色{background}{merged}',
  'toast.conversionFailed': '変換に失敗したため、前の図案が復元されました。',
  'toast.conversionTimeout': '処理時間が長すぎたためキャンセルされ、前の図案が復元されました。詳細写真モードを使うか画像サイズを縮小してください。',
  'toast.cropTooSmall': '切り抜き範囲が小さすぎます。もっと広いエリアを選択してください。',
  'toast.csvExported': '材料リストを出力しました: {colors} 色、{beads} 粒。',
  'toast.documentDetected': '複雑な文書を検出しました。文書構造モードに切り替えるか、制作したい領域を切り抜いてください。',
  'toast.documentPreview': '文書構造プレビューが作成されました。本文テキストは判読できません。',
  'toast.draftCleared': '端末の一時復元記録を消去しました。',
  'toast.draftInvalid': '復元データが無効または破損していたため安全に消去されました。',
  'toast.draftStorage': 'ブラウザの一時保存領域がいっぱいです。プロジェクトファイルを手動保存してください。',
  'toast.emptyPicker': '空白マスには色番号がありません。色の付いたマスを選択してください。',
  'toast.exportDone': '色番号入り制作図を出力しました。',
  'toast.exportFailed': '出力に失敗しました。図案サイズを小さくして再試行してください。',
  'toast.exportMemory': '端末のメモリ制限により特大画像の生成が制限されています。サイズを縮小するか分割印刷をご利用ください。',
  'toast.generatedWarning': '生成されましたが、{warning}。マス数を増やすかブラシで補正してください。',
  'toast.imageDamaged': '画像が破損しているか非対応形式です。標準的な画像ファイルをお使いください。',
  'toast.imagePixelsTooLarge': '画像のピクセル数が多すぎます。解像度を下げて再試行してください。',
  'toast.imageTooLarge': '画像が24MBを超えています。圧縮してから再試行してください。',
  'toast.invalidImage': '画像ヘッダーが無効または破損しています。標準的なPNG、JPG、WebP、または静止GIFをお使いください。',
  'toast.makingReset': '制作進捗をリセットしました。',
  'toast.makingStarted': '制作アシスタントが有効になりました。キャンバス上で現在の色番号がハイライトされます。',
  'toast.noMaterials': 'この図案にはまだビーズが配置されていません。',
  'toast.photoModeAuto': '詳細な写真を検出したため、長時間の処理を避けるべく詳細写真モードに自動切り替えしました。',
  'toast.previewEditZoom': '現在は全体表示です。マスを編集するにはズームインしてください。',
  'toast.printFailed': '印刷プレビューに失敗しました。サイズを小さくするか PNG 出力をお試しください。',
  'toast.projectDownloadStarted': 'プロジェクトのダウンロードを開始しました。元画像は含まれません。',
  'toast.projectInvalid': 'プロジェクトの形式が無効または非対応のバージョンです。',
  'toast.projectLoaded': 'プロジェクトを読み込みました。',
  'toast.projectMigrated': '旧64色プロジェクトを互換基本221色番号に移行しました。',
  'toast.projectRestored': '未完成のプロジェクトを復元しました（元画像なし）。編集を続行できます。',
  'toast.projectSaved': 'プロジェクトファイルに保存しました（元画像は含まれません）。',
  'toast.projectTooLarge': 'プロジェクトファイルが空か、大きすぎます。',
  'toast.safeDecodeFailed': '大容量画像のデコードに失敗しました。圧縮してから再試行してください。',
  'toast.sampleFailed': '内蔵サンプルを読み込めませんでした。ローカル画像を選択してください。',
  'toast.statsCopied': '材料リストをコピーしました。メモ帳や発注メッセージに貼り付けてください。',
  'toast.statsCopyFailed': 'コピーに失敗しました。手動で記録してください。',
  'toast.workerUnsupported': '安全なバックグラウンド変換が利用できません。Chrome、Edge、Firefox、Safari の最新版をお使いください。',
  'toast.zoomLimit': 'メモリ保護のため、この {cols}×{rows} の図案はズーム倍率が {percent}% に制限されます。',
  'tool.brush': 'ブラシ B',
  'tool.clear': '図案をクリア',
  'tool.eraser': '消しゴム E',
  'tool.mirrorH': '水平反転',
  'tool.mirrorV': '垂直反転',
  'tool.picker': 'スポイト I',
  'tool.rotate': '時計回りに 90° 回転',
  'tools.subtitle': 'ドラッグで連続描画可能',
  'tools.title': '描画と変形',
  'unit.beads': '{formatted} 粒',
  'unit.colors': '{count} 色',
  'unit.colorsValue': '{count} 色',
  'view.codes': '色番号',
  'view.fit': '全体表示',
  'view.grid': 'グリッド',
  'view.ruler': 'ルーラー',
  'white.auto': '自動的に余白にする',
  'white.keep': '白いビーズを残す',
};
export default jaJP;
